import React, {useState} from "react";
import styled from "styled-components";
import {Link} from "react-router-dom";
import {
	IconAdCampaings, IconApps,
	IconDollar, IconDomains,
	IconPlus,
	IconPushNotifications,
	IconRightLong,
	IconTeams,
	IconTeams2,
	IconWallet
} from "../icons";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../../redux/store";
import {ButtonPrimary, ButtonSecondary} from "../button";
import {ModalTopUp} from "../modals";
import {ModalWithdraw} from "../modals/modal.withdraw";


const ICON_CARD_TITLE_SIZE = 16

const WidgetCard = styled(Link)`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 28px;
    align-self: stretch;

    border: 1px solid var(--it-stroke-grey);
    background: var(--it-bg-cards);
    backdrop-filter: blur(50px);
		transition: all 0.4s;

    .icon-right-long {
        transition: all 0.4s;
				transform: rotate(-45deg);
    }
		
		&:hover {
        border: 1px solid var(--it-stroke-blue);
        background: var(--it-bg-blue);
        backdrop-filter: blur(50px);

        .icon-right-long {
            transform: rotate(0);
				}
		}
`

export const CardHeader = styled.div`
		display: flex;
		align-items: center;
`

export const CardIcon = styled.span`
    color: var(--it-text-grey);
`

export const CardTitle = styled.div`
    color: var(--it-text-grey);
    /* Description */
    font-family: "Basis Grotesque Pro";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 12px */
    letter-spacing: 0.36px;
    text-transform: uppercase;
`

const CardFooter = styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
`

export const CardCount = styled.div`
    color: var(--it-text-white);

    /* H1 */
    font-family: "Druk Wide";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    letter-spacing: -0.72px;
`

const WidgetBalanceCard = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`

const CardBody = styled.div`

`

const BalanceLeftCont = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
`

const BalanceButtonsCont = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`

const WidgetInfoCountNew = ({title, icon, count, linkTo}) => {
	return (
		<WidgetCard to={linkTo}>
			<CardHeader>
				<CardIcon>{icon}</CardIcon>
				<CardTitle style={{paddingTop: '2px', paddingLeft: '4px'}}>{title}</CardTitle>
			</CardHeader>

			<CardFooter>
				<CardCount>{count}</CardCount>
				<CardIcon className='icon-right-long'><IconRightLong size={17} /></CardIcon>
			</CardFooter>
		</WidgetCard>
	)
}

export const WidgetBalance = () => {
	const {t} = useTranslation()
	const {user} = useAppSelector()
	const [isTopUpModalVisible, setTopUpModalVisible] = useState(false)
	const [isWithdrawModalVisible, setWithdrawModalVisible] = useState(false)

	return (
		<WidgetBalanceCard>
			<BalanceLeftCont>
				<CardHeader>
					<CardTitle>{t('widget.balance.title')}</CardTitle>
					<CardIcon style={{marginLeft: '6px'}}><IconDollar size={16}/></CardIcon>
				</CardHeader>
				<CardBody>
					<CardCount>${user.balance}</CardCount>

					{user?.balance_in_hold > 0 && (
						<CardTitle style={{marginTop: '5px'}}>{t('widget.balance.in_hold')}: <b>${user.balance_in_hold}</b></CardTitle>
					)}
				</CardBody>
			</BalanceLeftCont>

			<BalanceButtonsCont>
				<ButtonSecondary onClick={() => setTopUpModalVisible(true)}>
					<IconPlus size={20}/>
					{t(`widget.balance.topup`)}
				</ButtonSecondary>

				<ButtonSecondary onClick={() => setWithdrawModalVisible(true)}>
					<IconWallet size={20}/>
					{t(`widget.balance.withdraw`)}
				</ButtonSecondary>

				<Link to={'/apps/add'}>
					<ButtonPrimary>
						{t(`widget.balance.btn_create_pwa`)}
					</ButtonPrimary>
				</Link>
			</BalanceButtonsCont>

			<ModalTopUp
				isOpen={isTopUpModalVisible}
				onCancel={()=>setTopUpModalVisible(false)}
			/>
			<ModalWithdraw
				isOpen={isWithdrawModalVisible}
				onCancel={()=>setWithdrawModalVisible(false)}
			/>
		</WidgetBalanceCard>
	)
}

export const WidgetTeams = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.teams')} count={count} icon={<IconTeams2 size={ICON_CARD_TITLE_SIZE}/>} linkTo={'/teams/team'} />
}

export const WidgetUsers = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.users')} count={count} icon={<IconTeams size={ICON_CARD_TITLE_SIZE}/>} linkTo={'/admin/users'} />
}

export const WidgetPushs = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.pushs')} count={count} icon={<IconPushNotifications size={ICON_CARD_TITLE_SIZE}/>} linkTo={'/push/newsletters'} />
}

export const WidgetAdCampaigns = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.adcampaigns')} count={count} icon={<IconAdCampaings size={ICON_CARD_TITLE_SIZE}/>} linkTo={'/adcampaigns'} />

}

export const WidgetApps = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.apps')} count={count} icon={<IconApps size={ICON_CARD_TITLE_SIZE}/>} linkTo={'/apps'} />
}

export const WidgetDomains = ({count}) => {
	const {t} = useTranslation();
	return <WidgetInfoCountNew title={t('dashboard.widget.domains')} count={count} icon={<IconDomains size={ICON_CARD_TITLE_SIZE + 1}/>} linkTo={'/domains'} />
}